export default __webpack_public_path__ + "static/media/sVang-logo.328f46df.png";